
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

import Text from '../../common/client/components/Text';

const classNames = mergeStyleSets({
    valueTitle: {
        width: 150
    },
    valueValue: {

    }
});

const ObjectInfoValue = (props) => {

    return (
        <Stack horizontal verticalAlign="end">
            <Stack.Item>
                <div className={classNames.valueTitle}>
                    <Text>{props.item.title}:</Text>
                </div>
            </Stack.Item>
            <Stack.Item>
                <div className={classNames.valueValue}>
                    {isString(props.item.value) || isNumber(props.item.value)
                        ? <Text bold>{props.item.value}</Text>
                        : props.item.value
                    }
                </div>
            </Stack.Item>
        </Stack>
    );
};

const ObjectInfoValues = (props) => {
    return props.items.map((item, index) => {
        return <ObjectInfoValue key={index} item={item} />;
    });
};

export default ObjectInfoValues;
